import React, { Component } from 'react';
import { TrevorIcon } from '@trevor/ui-components';
import { postJson } from '@/util/helpers/ajax-helpers';
import { safeOnClick } from '@/util/helpers/event-helpers';
import AjaxSpinner from '../../components/AjaxSpinner';
import SuggestedView from '../../util/SuggestedView';
import ViewMeta from '../../util/ViewMeta';
import DashboardRef from '../../util/DashboardRef';
import css from '../../css/module/insights.css';
import flex from '../../css/module/flex.css';
import SearchInput from '../../components/SearchInput';
import CategoryRef from '../../util/CategoryRef';
import { ShowMoreButton } from '../../components/ShowMoreButton';
import { SEARCH_QUERIES_INPUT } from '../../constants/test-ids';
import { ALL, MINE, STARRED, SUGGESTED } from './consts';
import {
  CategoryFilters,
  SavedQuery,
  ShareToolFilters,
  SuggestedQueryInfo,
} from './subcomponents';
import {
  hasAlerts,
  hasDashboards,
  hasInsightError,
  hasS3Feeds,
  hasSlackAlerts,
  hasZaps,
  isGoogleSheetsSharable,
  isOtherShareable,
} from './helpers';

const SLACK_ALERTS = 'SLACK';
const EMAIL_ALERTS = 'EMAIL';
const GOOGLE_SHEETS = 'GOOGLE';
const S3_BUCKETS = 'S3_BUCKETS';
const ZAPIER = 'ZAPIER';

const DEFAULT_CATEGORIES_NAME = {
  [SLACK_ALERTS]: 'Slack alerts',
  [EMAIL_ALERTS]: 'Email alerts',
  [GOOGLE_SHEETS]: 'Google sheets feeds',
  [S3_BUCKETS]: 'S3 bucket feeds',
  [ZAPIER]: 'Zapier',
};

const RESULTS_TO_SHOW = 25;

export class SavedQueries_LEGACY extends Component {
  state = {
    resultsToShow: RESULTS_TO_SHOW,
    viewsMetas: {}, // ViewMeta objects by view series
    dashboardsById: {}, // DashboardRef by id
    dependantQueriesSeriesIds: {},
  };

  componentDidMount() {
    this.props.onEnterView();
    postJson('/views/meta').then((json) => {
      const { dependantQueriesSeriesIds, ...rest } = json;
      this.setState({
        viewsMetas: rest._metas.reduce((viewsMetas, rawMeta) => {
          const meta = ViewMeta.buildFromServer(rawMeta);
          viewsMetas[meta.viewSeries()] = meta;

          return viewsMetas;
        }, {}),
        dashboardsById: rest._dashboards.reduce(
          (dashboardsById, rawDashboard) => {
            const dashboard = DashboardRef.build(rawDashboard);
            dashboardsById[dashboard.id()] = dashboard;

            return dashboardsById;
          },
          {},
        ),
        dependantQueriesSeriesIds,
      });
    });
  }

  /**
   * Handles when the user selects a category to filter queries
   *
   * @param category
   *    Selected category
   */
  filterByCategory = (category) => {
    this.props.onCategoryClicked(category, this.props.state.filter);
  };

  // more button should be shown if no of results exceeds the limit of results we are showing (so users can load more if they want)
  handleShowMore = () => {
    this.setState((state) => ({
      resultsToShow: state.resultsToShow + RESULTS_TO_SHOW,
    }));
  };

  render() {
    const {
      state,
      myViews,
      userEmail,
      suggestions,
      isHerokuAddonUser,
      onImportClicked,
      onOpenShareModal,
      userInteraction,
      onStarClicked,
      onEditView,
      onDuplicateView,
      onDeleteView,
      onEditCategory,
      onDeleteCategory,
    } = this.props;

    const { viewsMetas, dashboardsById, dependantQueriesSeriesIds } =
      this.state;

    let views = (
      <div className={flex.middle}>
        <AjaxSpinner />
      </div>
    );

    const categoryFilter =
      state.categoryFilter instanceof CategoryRef
        ? state.tags.filter((e) => e.id() === state.categoryFilter.id())[0]
        : state.categoryFilter;

    const countViewsWithDefaultCategories = (allViews, category) => {
      switch (category) {
        case SLACK_ALERTS:
          return (
            (allViews &&
              allViews.filter(
                (v) =>
                  !(v[0] instanceof SuggestedView) &&
                  viewsMetas[v[0].series()] &&
                  viewsMetas[v[0].series()].slackDestinations().length > 0,
              ).length) ||
            0
          );
        case EMAIL_ALERTS:
          return (
            (allViews &&
              allViews.filter(
                (v) =>
                  !(v[0] instanceof SuggestedView) &&
                  viewsMetas[v[0].series()] &&
                  viewsMetas[v[0].series()].emailDestinations().length > 0,
              ).length) ||
            0
          );
        case GOOGLE_SHEETS:
          return (
            (allViews &&
              allViews.filter(
                (v) =>
                  !(v[0] instanceof SuggestedView) &&
                  viewsMetas[v[0].series()] &&
                  viewsMetas[v[0].series()].isSheetsShareable(),
              ).length) ||
            0
          );
        case S3_BUCKETS:
          return (
            (allViews &&
              allViews.filter(
                (v) =>
                  !(v[0] instanceof SuggestedView) &&
                  viewsMetas[v[0].series()] &&
                  viewsMetas[v[0].series()].bucketFeeds().length > 0,
              ).length) ||
            0
          );
        case ZAPIER:
          return (
            (allViews &&
              allViews.filter(
                (v) =>
                  !(v[0] instanceof SuggestedView) &&
                  viewsMetas[v[0].series()] &&
                  viewsMetas[v[0].series()].zapierCount() > 0,
              ).length) ||
            0
          );
      }
    };

    // put favourites first (without affecting sort order)
    const allViews = state.allViews
      ? [...state.allViews, ...suggestions.map((s) => [s, 'Trevor.io'])]
      : [];

    let filteredViewsCount = 0;

    if (state.allViews && myViews) {
      // render all views
      views = allViews.filter((entry) => {
        const viewRef = entry[0];
        const viewSeries = !(viewRef instanceof SuggestedView)
          ? viewRef.series()
          : null;
        const email = entry[1];
        const emailMatches =
          email === userEmail || (email === 'shared' && isHerokuAddonUser);
        const isFavourite =
          !(viewRef instanceof SuggestedView) &&
          state.favourites.find((series) => series === viewSeries);

        const meta = viewsMetas[viewSeries];

        const searchEmailAlert = hasAlerts(meta)
          ? `email alerts ${meta
              .emailDestinations()
              .map((e) => e)
              .join()}`
          : '';
        const searchSlackAlert = hasSlackAlerts(meta)
          ? `slack alerts ${meta
              .slackDestinations()
              .map((e) => e)
              .join()}`
          : '';
        const searchS3Buckets = hasS3Feeds(meta)
          ? `s3 bucket ${meta
              .bucketFeeds()
              .map((name) => name)
              .join()}`
          : '';
        const searchGoogleSheets = isGoogleSheetsSharable(meta)
          ? 'google sheets'
          : '';
        const searchDashboards = hasDashboards(meta)
          ? `dashboard ${meta
              .dashboardIds()
              .map((d) => dashboardsById[d].name())
              .join()}`
          : '';
        const searchZapier = hasZaps(meta) ? 'zapierzaps' : '';
        const searchOtherTools = isOtherShareable(meta) ? 'other tools' : '';
        const searchError = hasInsightError(meta) ? 'error' : '';

        /**
         * Check if any of the subfilters was selected to perform that filtering operation
         *
         * @returns {boolean}
         */
        const includeWithFilter = () =>
          !(
            (state.filter === STARRED && !isFavourite) ||
            (state.filter === MINE && !emailMatches) ||
            (state.filter === SUGGESTED && !(viewRef instanceof SuggestedView))
          );

        /**
         * Performs a category filter using default categories
         */
        const filterByDefaultCategory = () => {
          switch (categoryFilter) {
            case SLACK_ALERTS:
              return searchSlackAlert;
            case EMAIL_ALERTS:
              return searchEmailAlert;
            case GOOGLE_SHEETS:
              return searchGoogleSheets;
            case S3_BUCKETS:
              return searchS3Buckets;
            case ZAPIER:
              return searchZapier;
          }
        };

        const isFilteringByCustomCategory = () =>
          viewRef.categories() &&
          viewRef.categories().some((t) => t.id() === categoryFilter.id()) &&
          includeWithFilter();

        if (
          categoryFilter instanceof CategoryRef &&
          !(viewRef instanceof SuggestedView) &&
          !isFilteringByCustomCategory()
        ) {
          // User is filtering by a custom category
          return false;
        }
        if (categoryFilter !== ALL && viewRef instanceof SuggestedView) {
          return false;
        }
        if (
          !(categoryFilter instanceof CategoryRef) &&
          categoryFilter !== ALL &&
          !(filterByDefaultCategory() && includeWithFilter())
        ) {
          // User is filtering by default categories
          return false;
        }
        if (!includeWithFilter()) {
          return false;
        }

        // search works by splitting into terms (delimited by spaces) and making sure each appears
        if (
          state.search
            .toLowerCase()
            .split(' ')
            .some((term) => {
              return (
                viewRef.name().toLowerCase().indexOf(term) === -1 &&
                email.toLowerCase().indexOf(term) === -1 &&
                searchOtherTools.toLowerCase().indexOf(term) === -1 &&
                searchDashboards.toLowerCase().indexOf(term) === -1 &&
                searchError.toLowerCase().indexOf(term) === -1
              );
            })
        ) {
          return false;
        }
        return true;
      });

      filteredViewsCount = views.length;

      views = views
        .slice(0, this.state.resultsToShow)
        .map(([viewRef, email]) => {
          const viewSeries = !(viewRef instanceof SuggestedView)
            ? viewRef.series()
            : null;
          if (viewRef instanceof SuggestedView) {
            const name = viewRef.name();
            return (
              <SuggestedQueryInfo
                key={name}
                name={name}
                suggestedBy={email}
                querySql={viewRef.query()}
              />
            );
          }
          const isFavourite = Boolean(
            state.favourites.find((series) => series === viewRef.series()),
          );
          const meta = viewsMetas[viewSeries];

          // TODO: a hack. Find a way to put email into meta in a proper way during the next refactoring iteration.
          if (meta) {
            meta.email = email;
          }

          const { dependantQuerySeriesIds, dependantJoinSeriesIds } =
            dependantQueriesSeriesIds[viewRef.series()] ?? {};

          viewRef.dependantQuerySeriesIds = dependantQuerySeriesIds ?? [];
          viewRef.dependantJoinSeriesIds = dependantJoinSeriesIds ?? [];

          return (
            <SavedQuery
              key={viewRef.id()}
              savedQuery={viewRef}
              meta={meta}
              dashboardsById={dashboardsById}
              isFavourite={isFavourite}
              onDelete={onDeleteView(viewRef)}
              onDuplicate={onDuplicateView(viewRef)}
              onEdit={onEditView(viewRef)}
              onShare={onOpenShareModal(viewRef)}
              onToggleFavourite={onStarClicked(viewRef, !isFavourite)}
            />
          );
        });

      if (views.length === 0) {
        const msg =
          state.filter === STARRED ? (
            <div style={{ padding: '20px' }} className={css.insight}>
              <span>
                You have <b>0</b> starred queries. Click the <b>star icon</b> on
                any saved query to have it appear here.
              </span>
            </div>
          ) : state.search.trim().length === 0 ? (
            <div style={{ padding: '20px' }} className={css.insight}>
              <span>
                0 saved queries found. Use the <b>Query builder</b> to create
                and <b>save</b> queries.
              </span>
            </div>
          ) : (
            <div style={{ padding: '20px' }} className={css.insight}>
              <span>
                0 saved queries match your <b>search</b>. Clear the search{' '}
                <b>above</b> to see all.
              </span>
            </div>
          );
        views = <div className={css.results}>{msg}</div>;
      } else if (state.filter === MINE) {
        views = <div className={css.results}>{views}</div>;
      }
    }

    const showShowMoreButton =
      !!filteredViewsCount && filteredViewsCount > this.state.resultsToShow;

    const categoryTitle = () => {
      if (
        categoryFilter &&
        !(categoryFilter instanceof CategoryRef) &&
        categoryFilter !== ALL
      ) {
        return `${DEFAULT_CATEGORIES_NAME[categoryFilter]}`;
      }
      if (categoryFilter instanceof CategoryRef && categoryFilter !== ALL) {
        return `${categoryFilter.name()}`;
      }
      if (categoryFilter === ALL) {
        return 'All Queries';
      }
      return null;
    };

    return (
      <div className={css.viewsContent}>
        <div className={css.categoriesColumn}>
          <div className={css.categoriesSection}>
            <div
              onClick={() => this.filterByCategory(ALL)}
              className={`${css.tab} ${
                categoryFilter === ALL ? css.activeTab : ''
              }`}
            >
              <TrevorIcon name="floppy" className="margin-right-10" />
              All
            </div>
            <ShareToolFilters
              appliedFilter={categoryFilter}
              onApplyFilter={this.filterByCategory}
              getSavedQueriesCount={(shareToolType) =>
                countViewsWithDefaultCategories(state.allViews, shareToolType)
              }
            />
            <hr />
            <CategoryFilters
              categories={state.tags.sort((t1, t2) =>
                t1.name().localeCompare(t2.name()),
              )}
              appliedFilter={categoryFilter}
              onApplyFilter={this.filterByCategory}
              onEdit={onEditCategory}
              onDelete={onDeleteCategory}
            />
          </div>
        </div>
        <div className={css.contentColumn}>
          <div className={css.aboveControl}>
            <div className={`${css.title} ${flex.alignItemsCenter}`}>
              <div className={flex.column}>
                <span style={{ fontSize: '1.1em' }}>
                  Saved Queries
                  {Object.keys(DEFAULT_CATEGORIES_NAME).includes(categoryFilter)
                    ? ' / Feeds'
                    : state.tags.some(
                        (t) =>
                          categoryFilter instanceof CategoryRef &&
                          t.id() === categoryFilter.id(),
                      )
                    ? ' / Categories '
                    : null}
                </span>
                <h1 className="margin-top-10">{categoryTitle()}</h1>
              </div>
            </div>
          </div>
          <div
            className={css.controlContainer}
            style={{ top: '110px', paddingTop: '0px' }}
          >
            <div className={css.viewsControl}>
              <SearchInput
                value={state.search}
                onSearch={(value) =>
                  userInteraction({ section: 'search', value })()
                }
                placeholder="Search queries"
                id={SEARCH_QUERIES_INPUT}
              />
              <ul className="nav nav-pills view-pills">
                <li role="presentation" className="nav-item">
                  <a
                    href="#"
                    className={`${
                      state.filter === ALL ? 'active bg-secondary' : ''
                    } nav-link`}
                    onClick={userInteraction({
                      section: 'filter',
                      value: ALL,
                      categoryFilter,
                    })}
                  >
                    All
                  </a>
                </li>
                <li role="presentation" className="nav-item">
                  <a
                    href="#"
                    className={`${
                      state.filter === MINE ? 'active bg-secondary' : ''
                    } nav-link`}
                    onClick={userInteraction({
                      section: 'filter',
                      value: MINE,
                      categoryFilter,
                    })}
                  >
                    My queries
                  </a>
                </li>
                <li role="presentation" className="nav-item">
                  <a
                    href="#"
                    className={`${
                      state.filter === STARRED ? 'active bg-secondary' : ''
                    } nav-link`}
                    onClick={userInteraction({
                      section: 'filter',
                      value: STARRED,
                      categoryFilter,
                    })}
                  >
                    My starred
                  </a>
                </li>
                {suggestions.length === 0 || categoryFilter !== ALL ? null : (
                  <li role="presentation" className="nav-item">
                    <a
                      href="#"
                      className={`${
                        state.filter === SUGGESTED ? 'active bg-secondary' : ''
                      } nav-link`}
                      onClick={userInteraction({
                        section: 'filter',
                        value: SUGGESTED,
                        categoryFilter,
                      })}
                    >
                      Suggested
                    </a>
                  </li>
                )}
                {categoryFilter === ALL && (
                  <li className="nav-item ms-auto">
                    <a
                      className="nav-link text-dark"
                      href="#"
                      onClick={safeOnClick(onImportClicked)}
                    >
                      Import
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div className={css.insightsContainer}>
            {views}
            {showShowMoreButton && (
              <ShowMoreButton onClick={this.handleShowMore} />
            )}
          </div>
        </div>
      </div>
    );
  }
}
